// src/data/countries.js

// Lista de países formatada para o react-select: { value: 'BR', label: 'Brasil' }
// Esta é uma lista de exemplo. Você pode encontrar listas JSON completas online 
// para preencher este arquivo com todos os países do mundo.
export const countryOptions = [
    { value: 'AF', label: 'Afeganistão' },
    { value: 'ZA', label: 'África do Sul' },
    { value: 'AL', label: 'Albânia' },
    { value: 'DE', label: 'Alemanha' },
    { value: 'AD', label: 'Andorra' },
    { value: 'AO', label: 'Angola' },
    { value: 'AI', label: 'Anguilla' },
    { value: 'AG', label: 'Antígua e Barbuda' },
    { value: 'SA', label: 'Arábia Saudita' },
    { value: 'DZ', label: 'Argélia' },
    { value: 'AR', label: 'Argentina' },
    { value: 'AM', label: 'Armênia' },
    { value: 'AW', label: 'Aruba' },
    { value: 'AU', label: 'Austrália' },
    { value: 'AT', label: 'Áustria' },
    { value: 'AZ', label: 'Azerbaijão' },
    { value: 'BS', label: 'Bahamas' },
    { value: 'BH', label: 'Bahrein' },
    { value: 'BD', label: 'Bangladesh' },
    { value: 'BB', label: 'Barbados' },
    { value: 'BE', label: 'Bélgica' },
    { value: 'BZ', label: 'Belize' },
    { value: 'BJ', label: 'Benin' },
    { value: 'BM', label: 'Bermudas' },
    { value: 'BY', label: 'Bielorrússia' },
    { value: 'BO', label: 'Bolívia' },
    { value: 'BA', label: 'Bósnia e Herzegovina' },
    { value: 'BW', label: 'Botsuana' },
    { value: 'BR', label: 'Brasil' },
    { value: 'BN', label: 'Brunei' },
    { value: 'BG', label: 'Bulgária' },
    { value: 'BF', label: 'Burkina Faso' },
    { value: 'BI', label: 'Burundi' },
    { value: 'BT', label: 'Butão' },
    { value: 'CV', label: 'Cabo Verde' },
    { value: 'KH', label: 'Camboja' },
    { value: 'CM', label: 'Camarões' },
    { value: 'CA', label: 'Canadá' },
    { value: 'QA', label: 'Catar' },
    { value: 'KZ', label: 'Cazaquistão' },
    { value: 'TD', label: 'Chade' },
    { value: 'CL', label: 'Chile' },
    { value: 'CN', label: 'China' },
    { value: 'CY', label: 'Chipre' },
    { value: 'CO', label: 'Colômbia' },
    { value: 'KM', label: 'Comores' },
    { value: 'CG', label: 'Congo' },
    { value: 'CD', label: 'Congo (Rep. Dem.)' },
    { value: 'KR', label: 'Coreia do Sul' },
    { value: 'KP', label: 'Coreia do Norte' },
    { value: 'CR', label: 'Costa Rica' },
    { value: 'CI', label: 'Costa do Marfim' },
    { value: 'HR', label: 'Croácia' },
    { value: 'CU', label: 'Cuba' },
    { value: 'DK', label: 'Dinamarca' },
    { value: 'DJ', label: 'Djibuti' },
    { value: 'DM', label: 'Dominica' },
    { value: 'EG', label: 'Egito' },
    { value: 'SV', label: 'El Salvador' },
    { value: 'AE', label: 'Emirados Árabes Unidos' },
    { value: 'EC', label: 'Equador' },
    { value: 'ER', label: 'Eritreia' },
    { value: 'SK', label: 'Eslováquia' },
    { value: 'SI', label: 'Eslovênia' },
    { value: 'ES', label: 'Espanha' },
    { value: 'US', label: 'Estados Unidos' },
    { value: 'EE', label: 'Estônia' },
    { value: 'ET', label: 'Etiópia' },
    { value: 'FJ', label: 'Fiji' },
    { value: 'PH', label: 'Filipinas' },
    { value: 'FI', label: 'Finlândia' },
    { value: 'FR', label: 'França' },
    { value: 'GA', label: 'Gabão' },
    { value: 'GM', label: 'Gâmbia' },
    { value: 'GH', label: 'Gana' },
    { value: 'GE', label: 'Geórgia' },
    { value: 'GI', label: 'Gibraltar' },
    { value: 'GR', label: 'Grécia' },
    { value: 'GD', label: 'Granada' },
    { value: 'GL', label: 'Groenlândia' },
    { value: 'GP', label: 'Guadalupe' },
    { value: 'GU', label: 'Guam' },
    { value: 'GT', label: 'Guatemala' },
    { value: 'GG', label: 'Guernsey' },
    { value: 'GY', label: 'Guiana' },
    { value: 'GF', label: 'Guiana Francesa' },
    { value: 'GN', label: 'Guiné' },
    { value: 'GQ', label: 'Guiné Equatorial' },
    { value: 'GW', label: 'Guiné-Bissau' },
    { value: 'HT', label: 'Haiti' },
    { value: 'NL', label: 'Holanda' },
    { value: 'HN', label: 'Honduras' },
    { value: 'HK', label: 'Hong Kong' },
    { value: 'HU', label: 'Hungria' },
    { value: 'YE', label: 'Iêmen' },
    { value: 'IN', label: 'Índia' },
    { value: 'ID', label: 'Indonésia' },
    { value: 'IQ', label: 'Iraque' },
    { value: 'IR', label: 'Irã' },
    { value: 'IE', label: 'Irlanda' },
    { value: 'IS', label: 'Islândia' },
    { value: 'IL', label: 'Israel' },
    { value: 'IT', label: 'Itália' },
    { value: 'JM', label: 'Jamaica' },
    { value: 'JP', label: 'Japão' },
    { value: 'JE', label: 'Jersey' },
    { value: 'JO', label: 'Jordânia' },
    { value: 'KW', label: 'Kuwait' },
    { value: 'LA', label: 'Laos' },
    { value: 'LS', label: 'Lesoto' },
    { value: 'LV', label: 'Letônia' },
    { value: 'LB', label: 'Líbano' },
    { value: 'LR', label: 'Libéria' },
    { value: 'LY', label: 'Líbia' },
    { value: 'LI', label: 'Liechtenstein' },
    { value: 'LT', label: 'Lituânia' },
    { value: 'LU', label: 'Luxemburgo' },
    { value: 'MO', label: 'Macau' },
    { value: 'MK', label: 'Macedônia do Norte' },
    { value: 'MG', label: 'Madagáscar' },
    { value: 'MY', label: 'Malásia' },
    { value: 'MW', label: 'Malawi' },
    { value: 'MV', label: 'Maldivas' },
    { value: 'ML', label: 'Mali' },
    { value: 'MT', label: 'Malta' },
    { value: 'MA', label: 'Marrocos' },
    { value: 'MQ', label: 'Martinica' },
    { value: 'MU', label: 'Maurício' },
    { value: 'MR', label: 'Mauritânia' },
    { value: 'YT', label: 'Mayotte' },
    { value: 'MX', label: 'México' },
    { value: 'FM', label: 'Micronésia' },
    { value: 'MD', label: 'Moldávia' },
    { value: 'MC', label: 'Mônaco' },
    { value: 'MN', label: 'Mongólia' },
    { value: 'ME', label: 'Montenegro' },
    { value: 'MS', label: 'Montserrat' },
    { value: 'MZ', label: 'Moçambique' },
    { value: 'MM', label: 'Myanmar' },
    { value: 'NA', label: 'Namíbia' },
    { value: 'NR', label: 'Nauru' },
    { value: 'NP', label: 'Nepal' },
    { value: 'NI', label: 'Nicarágua' },
    { value: 'NE', label: 'Níger' },
    { value: 'NG', label: 'Nigéria' },
    { value: 'NO', label: 'Noruega' },
    { value: 'NC', label: 'Nova Caledônia' },
    { value: 'NZ', label: 'Nova Zelândia' },
    { value: 'OM', label: 'Omã' },
    { value: 'PW', label: 'Palau' },
    { value: 'PS', label: 'Palestina' },
    { value: 'PA', label: 'Panamá' },
    { value: 'PG', label: 'Papua-Nova Guiné' },
    { value: 'PK', label: 'Paquistão' },
    { value: 'PY', label: 'Paraguai' },
    { value: 'PE', label: 'Peru' },
    { value: 'PF', label: 'Polinésia Francesa' },
    { value: 'PL', label: 'Polônia' },
    { value: 'PT', label: 'Portugal' },
    { value: 'PR', label: 'Porto Rico' },
    { value: 'QA', label: 'Qatar' },
    { value: 'KE', label: 'Quênia' },
    { value: 'KG', label: 'Quirguistão' },
    { value: 'GB', label: 'Reino Unido' },
    { value: 'CF', label: 'República Centro-Africana' },
    { value: 'CZ', label: 'República Tcheca' },
    { value: 'DO', label: 'República Dominicana' },
    { value: 'RO', label: 'Romênia' },
    { value: 'RW', label: 'Ruanda' },
    { value: 'RU', label: 'Rússia' },
    { value: 'EH', label: 'Saara Ocidental' },
    { value: 'WS', label: 'Samoa' },
    { value: 'AS', label: 'Samoa Americana' },
    { value: 'SM', label: 'San Marino' },
    { value: 'SH', label: 'Santa Helena' },
    { value: 'LC', label: 'Santa Lúcia' },
    { value: 'BL', label: 'São Bartolomeu' },
    { value: 'ST', label: 'São Tomé e Príncipe' },
    { value: 'VC', label: 'São Vicente e Granadinas' },
    { value: 'SN', label: 'Senegal' },
    { value: 'SL', label: 'Serra Leoa' },
    { value: 'RS', label: 'Sérvia' },
    { value: 'SC', label: 'Seychelles' },
    { value: 'SG', label: 'Singapura' },
    { value: 'SY', label: 'Síria' },
    { value: 'SO', label: 'Somália' },
    { value: 'LK', label: 'Sri Lanka' },
    { value: 'SD', label: 'Sudão' },
    { value: 'SS', label: 'Sudão do Sul' },
    { value: 'SE', label: 'Suécia' },
    { value: 'CH', label: 'Suíça' },
    { value: 'SR', label: 'Suriname' },
    { value: 'TH', label: 'Tailândia' },
    { value: 'TW', label: 'Taiwan' },
    { value: 'TJ', label: 'Tajiquistão' },
    { value: 'TZ', label: 'Tanzânia' },
    { value: 'IO', label: 'Território Britânico do Oceano Índico' },
    { value: 'TF', label: 'Territórios Franceses do Sul' },
    { value: 'TL', label: 'Timor-Leste' },
    { value: 'TG', label: 'Togo' },
    { value: 'TO', label: 'Tonga' },
    { value: 'TT', label: 'Trinidad e Tobago' },
    { value: 'TN', label: 'Tunísia' },
    { value: 'TM', label: 'Turcomenistão' },
    { value: 'TR', label: 'Turquia' },
    { value: 'TV', label: 'Tuvalu' },
    { value: 'UA', label: 'Ucrânia' },
    { value: 'UG', label: 'Uganda' },
    { value: 'UY', label: 'Uruguai' },
    { value: 'UZ', label: 'Uzbequistão' },
    { value: 'VU', label: 'Vanuatu' },
    { value: 'VA', label: 'Vaticano' },
    { value: 'VE', label: 'Venezuela' },
    { value: 'VN', label: 'Vietnã' },
    { value: 'WF', label: 'Wallis e Futuna' },
    { value: 'ZM', label: 'Zâmbia' },
    { value: 'ZW', label: 'Zimbábue' }
];